import { CountryCode } from '~shared/constants/country-code.enum';

export enum PAYMENT_SVG_NAMES {
  masterCardPayment = '/images/payment-mc.svg',
  visaPayment = '/images/payment-visa.svg',
  payPal = '/images/icons/paypal-footer.svg',
  invoicePayment = '/images/payment-invoice.svg',
  sepaPayment = '/images/payment-sepa.svg',
  sofortPayment = '/images/icons/klarna-footer-logo.svg',
  idealPayment = '/images/icons/iDEAL.svg',
  carteBancaires = '/images/icons/carte-bancaires.svg',
}

export const FOOTER_IMAGES = {
  [CountryCode.Germany]: [
    PAYMENT_SVG_NAMES.masterCardPayment,
    PAYMENT_SVG_NAMES.visaPayment,
    PAYMENT_SVG_NAMES.invoicePayment,
    PAYMENT_SVG_NAMES.sepaPayment,
    PAYMENT_SVG_NAMES.payPal,
    PAYMENT_SVG_NAMES.sofortPayment,
  ],
  [CountryCode.Spain]: [PAYMENT_SVG_NAMES.masterCardPayment, PAYMENT_SVG_NAMES.visaPayment, PAYMENT_SVG_NAMES.payPal],
  [CountryCode.Italy]: [PAYMENT_SVG_NAMES.masterCardPayment, PAYMENT_SVG_NAMES.visaPayment, PAYMENT_SVG_NAMES.payPal],
  [CountryCode.Portugal]: [
    PAYMENT_SVG_NAMES.masterCardPayment,
    PAYMENT_SVG_NAMES.visaPayment,
    PAYMENT_SVG_NAMES.payPal,
  ],
  [CountryCode.Netherlands]: [
    PAYMENT_SVG_NAMES.masterCardPayment,
    PAYMENT_SVG_NAMES.visaPayment,
    PAYMENT_SVG_NAMES.payPal,
    PAYMENT_SVG_NAMES.idealPayment,
  ],
  [CountryCode.France]: [
    PAYMENT_SVG_NAMES.masterCardPayment,
    PAYMENT_SVG_NAMES.visaPayment,
    PAYMENT_SVG_NAMES.carteBancaires,
    PAYMENT_SVG_NAMES.payPal,
    PAYMENT_SVG_NAMES.sofortPayment,
  ],
};
